module.exports = __webpack_public_path__ + "img/report-icon-dark.233798e1.svg";